var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"pseudo-modal-name",rawName:"v-pseudo-modal-name",value:('json-editor'),expression:"'json-editor'"}],on:{"mousedown":function($event){_vm.isFocus = true}}},[_c('v-jsoneditor',{attrs:{"options":_vm.options},model:{value:(_vm.json),callback:function ($$v) {_vm.json=$$v},expression:"json"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }